import { Directive } from '@angular/core';

@Directive({
  selector: '.sproutFieldSelector'
})
export class SproutFieldSelectorDirective {


}
